import { FETCH_FOLLOWUP_LEADS_SUCCESS, FETCH_FOLLOWUP_MAPPING, FETCH_FOLLOWUP_LEAD_DETAIL_SUCCESS, FETCH_FOLLOWUP_LEAD_COMMENTS_SUCCESS, FETCH_FOLLOWUP_TASKS_SUCCESS, FETCH_FOLLOWUP_LEAD_TASKS_SUCCESS, FETCH_FOLLOWUP_LEAD_HISTORY_SUCCESS } from '../actions/actiontypes';

export default function (state = {}, action) {
    switch (action.type) {
        case FETCH_FOLLOWUP_LEADS_SUCCESS: {
            return { ...state, leads: action.payload, leadDataReceived: true };
        }
        case FETCH_FOLLOWUP_LEAD_DETAIL_SUCCESS: {
            return { ...state, leadData: action.payload, leadDetailsReceived: true };
        }
        case FETCH_FOLLOWUP_LEAD_COMMENTS_SUCCESS: {
            return { ...state, leadComments: action.payload };
        }
        case FETCH_FOLLOWUP_TASKS_SUCCESS: {
            return { ...state, tasks: action.payload, taskDataReceived: true };
        }
        case FETCH_FOLLOWUP_LEAD_TASKS_SUCCESS: {
            return { ...state, leadTasks: action.payload };
        }
        case FETCH_FOLLOWUP_LEAD_HISTORY_SUCCESS: {
            return { ...state, leadHistory: action.payload };
        }
        case FETCH_FOLLOWUP_MAPPING: {
            return { ...state, mapping: action.payload };
        }
        default:
            return state;
    }
}